import React from 'react';

const CuentaDesactivada = () => (
  <div className="container text-center mt-5">
    <h1 className="text-danger">⛔ Cuenta Desactivada</h1>
    <p>Contacte al administrador para reactivar su cuenta</p>
  </div>
);

export default CuentaDesactivada;